import './vendor.ts';

import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Ng2Webstorage } from 'ng2-webstorage';

import { TmmsaisineAccountModule } from './account/account.module';
import { TmmsaisineAdminModule } from './admin/admin.module';
import { TmmsaisineEntityModule } from './entities/entity.module';
import { TmmsaisineHomeModule } from './home/home.module';
import { TmmsaisineSharedModule, UserRouteAccessService } from './shared';

import { TmmsaisineInternalModule } from './internal/internal.module';

import { PaginationConfig } from './blocks/config/uib-pagination.config';
import { customHttpProvider } from './blocks/interceptor/http.provider';
import { LayoutRoutingModule } from './layouts';

import { NgIdleModule } from '@ng-idle/core';
import { RegionService } from './admin/user-management/region.service';
import { CampaignService } from './entities/campaign/campaign.service';
import { TmmsaisineMasterProposalModule } from './entities/master-proposal/master-proposal.module';
import { MasterProposalService } from './entities/master-proposal/master-proposal.service';
import { LicenceToMasterService } from './entities/master/licence-to-master.service';
import { PropertiesService } from './entities/saisine/properties.service';
import { TmmsaisineStatModule } from './entities/stat/stat.module';
import { StatService } from './entities/stat/stat.service';
import { HomeService } from './home/home.service';
import { ErrorComponent, FooterComponent, JhiMainComponent, PageRibbonComponent, ProfileService } from './layouts';
import { HeaderComponent } from './layouts/header/header.component';
import { DownloadService } from './shared/download/download.service';
import { UtilsService } from './shared/utils/utils.service';

export function initCampaign(campaignService: CampaignService) { return () => campaignService.loadCampaigns(); }
export function initProperties(propertiesService: PropertiesService) { return () => propertiesService.loadProperties(); }
export function initHeaderLinks(propertiesService: PropertiesService) { return () => propertiesService.loadHeaderLinks(); }
export function initFooterLinks(propertiesService: PropertiesService) { return () => propertiesService.loadFooterLinks(); }

@NgModule({
    imports: [
        BrowserModule,
        LayoutRoutingModule,
        Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-' }),
        TmmsaisineSharedModule,
        TmmsaisineHomeModule,
        TmmsaisineAdminModule,
        TmmsaisineAccountModule,
        TmmsaisineEntityModule,
        TmmsaisineInternalModule,
        TmmsaisineMasterProposalModule,
        TmmsaisineStatModule,
        NgIdleModule.forRoot()
    ],
    declarations: [
        JhiMainComponent,
        ErrorComponent,
        PageRibbonComponent,
        FooterComponent,
        HeaderComponent,
    ],
    providers: [
        ProfileService,
        { provide: Window, useValue: window },
        { provide: Document, useValue: document },
        customHttpProvider(),
        PaginationConfig,
        UserRouteAccessService,
        HomeService,
        RegionService,
        UtilsService,
        MasterProposalService,
        LicenceToMasterService,
        StatService,
        DownloadService,
        CampaignService,
        PropertiesService,
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        { provide: APP_INITIALIZER, useFactory: initCampaign, deps: [CampaignService], multi: true },
        { provide: APP_INITIALIZER, useFactory: initProperties, deps: [PropertiesService], multi: true },
        { provide: APP_INITIALIZER, useFactory: initHeaderLinks, deps: [PropertiesService], multi: true },
        { provide: APP_INITIALIZER, useFactory: initFooterLinks, deps: [PropertiesService], multi: true }
    ],
    bootstrap: [JhiMainComponent]
})
export class TmmsaisineAppModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.module.ts